var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "content" },
    [
      _c("div", { staticClass: "head-body" }, [
        _vm._m(0),
        _vm._v(" "),
        _c("div", { staticClass: "head-search-body" }, [
          _c("div", { staticClass: "head-search" }, [
            _vm._m(1),
            _vm._v(" "),
            _c("div", { staticClass: "search-text" }, [
              _c("input", {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model",
                    value: _vm.searchInputValue,
                    expression: "searchInputValue"
                  }
                ],
                attrs: { type: "text", placeholder: "搜索网盘文件" },
                domProps: { value: _vm.searchInputValue },
                on: {
                  keyup: function($event) {
                    if (
                      !$event.type.indexOf("key") &&
                      _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")
                    ) {
                      return null
                    }
                    return _vm.search.apply(null, arguments)
                  },
                  input: function($event) {
                    if ($event.target.composing) {
                      return
                    }
                    _vm.searchInputValue = $event.target.value
                  }
                }
              }),
              _vm._v(" "),
              _vm.searchInputValue.length > 0
                ? _c(
                    "div",
                    {
                      staticClass: "ic-clean",
                      on: { click: _vm.cleanSearchValue }
                    },
                    [
                      _c("img", {
                        attrs: {
                          src: require("@/assets/ic_clean.png"),
                          alt: "clean"
                        }
                      })
                    ]
                  )
                : _vm._e()
            ])
          ]),
          _vm._v(" "),
          _c(
            "div",
            {
              staticClass: "head-download-body",
              on: { mouseenter: _vm.showQrCode, mouseleave: _vm.hideQrCode }
            },
            [
              _c("img", {
                attrs: { src: require("../assets/ic_download.png"), alt: "" }
              })
            ]
          ),
          _vm._v(" "),
          _vm.isHovered
            ? _c(
                "div",
                {
                  staticClass: "hover-display",
                  style: {
                    top: _vm.position.top + "px",
                    left: _vm.position.left + "px"
                  }
                },
                [
                  _vm._t("default", function() {
                    return [
                      _c(
                        "div",
                        { staticClass: "download-body" },
                        [
                          _c("div", { staticClass: "title" }, [
                            _vm._v("扫码下载")
                          ]),
                          _vm._v(" "),
                          _c("div", { staticClass: "app-name" }, [
                            _vm._v("快兔APP")
                          ]),
                          _vm._v(" "),
                          _c("QrcodeGenerator", {
                            attrs: {
                              text: _vm.qrCodeText,
                              size: 131,
                              options: {
                                color: { dark: "#000000", light: "#ffffff" }
                              }
                            }
                          })
                        ],
                        1
                      )
                    ]
                  })
                ],
                2
              )
            : _vm._e()
        ])
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "content-body" }, [
        _c("div", { staticClass: "left-tab" }, [
          _c("div", { staticClass: "user-info" }, [
            _c("div", { staticClass: "user-info-body" }, [
              _c("div", { staticClass: "user-img" }, [
                _c("img", { attrs: { src: _vm.userInfo.avatar } })
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "user-msg-body" }, [
                _c("div", { staticClass: "user-name-body" }, [
                  _c("div", { staticClass: "user-name" }, [
                    _vm._v(
                      "\n                " +
                        _vm._s(_vm.userInfo.nickname) +
                        "\n              "
                    )
                  ]),
                  _vm._v(" "),
                  _vm.userInfo.vip_status == 1
                    ? _c("div", { staticClass: "user-vip" }, [
                        _c("img", {
                          attrs: {
                            src: require("../assets/ic_vip.png"),
                            alt: ""
                          }
                        })
                      ])
                    : _vm._e()
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "progress-container" }, [
                  _c("div", { staticClass: "progress-bar" }, [
                    _c("div", {
                      staticClass: "progress",
                      style: { width: _vm.userVipInfo.vip_info.used_rate + "%" }
                    })
                  ])
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "user-capacity-body" }, [
                  _c("div", { staticClass: "user-capacity" }, [
                    _vm._v(
                      "\n                " +
                        _vm._s(_vm.userVipInfo.vip_info.use_space) +
                        _vm._s(_vm.userVipInfo.vip_info.use_space_unit) +
                        " /\n                " +
                        _vm._s(_vm.userVipInfo.vip_info.max_space) +
                        _vm._s(_vm.userVipInfo.vip_info.max_space_unit) +
                        "\n              "
                    )
                  ])
                ])
              ])
            ])
          ]),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "tab-body" },
            _vm._l(_vm.tabs, function(item, index) {
              return _c(
                "div",
                {
                  key: index,
                  staticClass: "tab-item",
                  class: { "item-selected": index == _vm.tabIndex },
                  on: {
                    click: function($event) {
                      return _vm.changeTab(index)
                    }
                  }
                },
                [
                  _c("div", { staticClass: "item-icon" }, [
                    _c("img", {
                      attrs: {
                        src:
                          index === _vm.tabIndex ? item.iconSelected : item.icon
                      }
                    })
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "item-label" }, [
                    _vm._v(_vm._s(item.label))
                  ])
                ]
              )
            }),
            0
          ),
          _vm._v(" "),
          _c("div", { staticClass: "log-out" }, [
            _c(
              "div",
              { staticClass: "log-out-btn", on: { click: _vm.logOut } },
              [_vm._v("\n          退出登录\n        ")]
            )
          ])
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "body" }, [
          _c("div", { staticClass: "body-head-content" }, [
            _c("div", { staticClass: "body-head" }, [
              _c("div", { staticClass: "option-btns" }, [
                _c("input", {
                  ref: "fileInput",
                  staticStyle: { display: "none" },
                  attrs: { type: "file", multiple: "" },
                  on: { change: _vm.handleFileChange }
                }),
                _vm._v(" "),
                _vm.userVipInfo.role_type === 2
                  ? _c(
                      "div",
                      {
                        staticClass: "btn add",
                        on: { click: _vm.selectedFile }
                      },
                      [_vm._v("上传文件")]
                    )
                  : _vm._e(),
                _vm._v(" "),
                _c(
                  "div",
                  {
                    staticClass: "btn create",
                    on: { click: _vm.createDirOpen }
                  },
                  [_vm._v("新建文件夹")]
                )
              ]),
              _vm._v(" "),
              _vm.tabIndex != 1 && _vm.tabIndex != 6 && _vm.tabIndex != 7
                ? _c(
                    "div",
                    { staticClass: "option-file-btns" },
                    _vm._l(_vm.optionFileBtns, function(item, index) {
                      return item.isVisible
                        ? _c(
                            "div",
                            {
                              key: index,
                              staticClass: "file-btn",
                              class: {
                                "last-file-btn":
                                  index + 1 == _vm.optionFileBtns.length,
                                "btn-display": item.display
                              },
                              on: {
                                click: function($event) {
                                  return _vm.optionFun(item.type)
                                }
                              }
                            },
                            [
                              _vm._v(
                                "\n              " +
                                  _vm._s(item.label) +
                                  "\n            "
                              )
                            ]
                          )
                        : _vm._e()
                    }),
                    0
                  )
                : _vm._e(),
              _vm._v(" "),
              _vm.tabIndex == 6
                ? _c(
                    "div",
                    { staticClass: "option-file-btns" },
                    _vm._l(_vm.recycleBtns, function(item, index) {
                      return _c(
                        "div",
                        {
                          key: index,
                          staticClass: "file-btn",
                          class: {
                            "last-file-btn":
                              index + 1 == _vm.recycleBtns.length,
                            "btn-display": item.display
                          },
                          on: {
                            click: function($event) {
                              return _vm.recycleOptionFun(item.type)
                            }
                          }
                        },
                        [
                          _vm._v(
                            "\n              " +
                              _vm._s(item.label) +
                              "\n            "
                          )
                        ]
                      )
                    }),
                    0
                  )
                : _vm._e()
            ])
          ]),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "tab-content" },
            [
              _c(
                _vm.currentTabComponent,
                _vm._b(
                  {
                    key: _vm.tabIndex,
                    ref: "tabChild",
                    tag: "component",
                    attrs: { "search-value": _vm.searchValue },
                    on: {
                      selectionList: _vm.selectionList,
                      changeRecycleSelectedData: _vm.changeRecycleSelectedData,
                      cleanRecycleDisplay: _vm.cleanRecycleDisplay,
                      changeDirId: _vm.changeDirId
                    }
                  },
                  "component",
                  _vm.currentTabProps,
                  false
                )
              )
            ],
            1
          )
        ])
      ]),
      _vm._v(" "),
      _vm._m(2),
      _vm._v(" "),
      _c("UploadProgressDialog", {
        attrs: {
          isVisible: _vm.isUploadModalVisible,
          uploadTaskList: _vm.uploadTaskList
        },
        on: {
          pauseUpload: _vm.pauseUpload,
          resumeUpload: _vm.resumeUpload,
          "update:isVisible": function($event) {
            _vm.isUploadModalVisible = $event
          }
        }
      }),
      _vm._v(" "),
      _c("CreateDirDialog", {
        attrs: {
          isVisible: _vm.isOpenCreateVisible,
          editFile: _vm.editFile,
          title: _vm.createVisibleTitle
        },
        on: {
          "update:isVisible": function($event) {
            _vm.isOpenCreateVisible = $event
          },
          submitCreateDir: _vm.submitCreateDir,
          submitRename: _vm.submitRename
        }
      }),
      _vm._v(" "),
      _c("DirListDialog", {
        attrs: {
          isVisible: _vm.isDirListVisible,
          selectionFile: _vm.selectionFile
        },
        on: {
          "update:isVisible": function($event) {
            _vm.isDirListVisible = $event
          },
          reloadFiles: _vm.reloadFiles
        }
      }),
      _vm._v(" "),
      _c("OpenMemberDialog", {
        attrs: {
          isVisible: _vm.isOpenMemberVisible,
          userVipInfo: _vm.userVipInfo
        },
        on: {
          "update:isVisible": function($event) {
            _vm.isOpenMemberVisible = $event
          }
        }
      })
    ],
    1
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "head-logo" }, [
      _c("img", { attrs: { src: require("../assets/logo_name.png"), alt: "" } })
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "search-ic" }, [
      _c("img", { attrs: { src: require("../assets/ic_search.png"), alt: "" } })
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "copyright" }, [
      _vm._v("\n    Copyright © 2024 深圳市寻讯科技有限公司 版权所有 "),
      _c(
        "a",
        {
          attrs: {
            href: "https://beian.miit.gov.cn/#/Integrated/index",
            target: "_blank",
            rel: "noopener noreferrer"
          }
        },
        [_vm._v(" 粤ICP备2024291999号")]
      )
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-71909fcb", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-71909fcb","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/content/index_page.vue
// module id = null
// module chunks = 